import type {
  CreatePlatformTenantRequest,
  CreatePlatformUserRequest,
  PlatformAssignableBot,
  PlatformTenant,
  PlatformUser,
  PlatformUserBotAccess,
  PlatformUserBotAccessMode,
  PlatformUserFeatureAccess,
  TenantConfig,
  TenantFeature,
  UpdatePlatformUserBotAccessRequest,
  UpdatePlatformUserFeatureAccessRequest,
  UpdatePlatformTenantRequest,
  UpdatePlatformUserRequest,
} from '@workspace/types';

export type {
  CreatePlatformTenantRequest,
  CreatePlatformUserRequest,
  PlatformAssignableBot,
  PlatformTenant,
  PlatformUser,
  PlatformUserBotAccess,
  PlatformUserBotAccessMode,
  PlatformUserFeatureAccess,
  TenantConfig,
  TenantFeature,
  UpdatePlatformUserBotAccessRequest,
  UpdatePlatformUserFeatureAccessRequest,
  UpdatePlatformTenantRequest,
  UpdatePlatformUserRequest,
};

export const MODULE_FEATURES: Array<{ value: TenantFeature; label: string }> = [
  { value: 'chatbot', label: 'Chatbot' },
  { value: 'helpdesk', label: 'Mesa de ayuda' },
  { value: 'chatwoot-integration', label: 'Chatwoot' },
  { value: 'whatsapp-360dialog', label: 'WhatsApp — 360dialog' },
  { value: 'whatsapp-twilio', label: 'WhatsApp — Twilio' },
  { value: 'whatsapp-evohub', label: 'WhatsApp — Evo Hub (evoapicloud)' },
  { value: 'whatsapp-waha', label: 'WhatsApp — número propio (WAHA / Go)' },
  { value: 'telegram-integration', label: 'Telegram' },
  { value: 'facebook-integration', label: 'Facebook Messenger' },
  { value: 'instagram-integration', label: 'Instagram DM' },
  { value: 'contact-agent', label: 'Agente de Contacto' },
  { value: 'leads', label: 'Embudo de leads' },
  { value: 'sms-integration', label: 'SMS' },
  { value: 'email-integration', label: 'Email' },
];

export const TENANT_FEATURES: Array<{ value: TenantFeature; label: string }> = [
  { value: 'chatbot', label: 'Chatbot' },
  { value: 'analytics', label: 'Analytics' },
  { value: 'export', label: 'Exportaciones' },
  { value: 'whatsapp-360dialog', label: 'WhatsApp — 360dialog' },
  { value: 'whatsapp-twilio', label: 'WhatsApp — Twilio' },
  { value: 'whatsapp-evohub', label: 'WhatsApp — Evo Hub (evoapicloud)' },
  { value: 'whatsapp-waha', label: 'WhatsApp — número propio (WAHA / Go)' },
  { value: 'telegram-integration', label: 'Telegram (Bot API)' },
  { value: 'facebook-integration', label: 'Facebook Messenger (Evo Hub)' },
  { value: 'instagram-integration', label: 'Instagram DM (Evo Hub)' },
  { value: 'helpdesk', label: 'Mesa de ayuda (nativa)' },
  { value: 'chatwoot-integration', label: 'Chatwoot (inbox + handoff)' },
  { value: 'contact-agent', label: 'Agente de Contacto' },
  { value: 'leads', label: 'Embudo de leads' },
  { value: 'contact-agent-audience-engine', label: 'Motor de audiencia congelada (Commander)' },
  { value: 'sms-integration', label: 'SMS (Twilio)' },
  { value: 'email-integration', label: 'Email (SendGrid)' },
];

export const DEFAULT_TENANT_CONFIG: TenantConfig = {
  maxUsers: 10,
  maxBots: 2,
  features: ['chatbot'],
};
